(function () {
  var calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var t = document.title;
  document.addEventListener('visibilitychange', function () {
    document.title = document.hidden ? '👻 Come back...' : t;
  });

  /* ---------- Cart (drawer) ---------- */
  var d = document.getElementById('cart-drawer');
  if (d) {
    var $ = function (id) { return document.getElementById(id); };
    var thr = parseInt(d.getAttribute('data-threshold'), 10) || 0;
    var code = '';
    try { code = localStorage.getItem('promo') || ''; } catch (e) {}
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
    function money(c, cur) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur || 'USD' }).format(c / 100);
    }
    function open() { document.body.classList.add('cart-open'); d.setAttribute('aria-hidden', 'false'); $('cart-close').focus(); }
    function close() { document.body.classList.remove('cart-open'); d.setAttribute('aria-hidden', 'true'); }
    function bump() { var b = $('cart-open'); b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); }
    function checkoutUrl() { return '/checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''); }

    function render(c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = c.item_count; });
      d.classList.toggle('empty', c.item_count === 0);
      var ship = d.querySelector('.ship');
      if (!thr) { ship.hidden = true; }
      else {
        var left = thr - c.total_price;
        $('ship-fill').style.width = Math.min(100, Math.round(c.total_price / thr * 100)) + '%';
        $('ship-fill').classList.toggle('done', left <= 0 && c.item_count > 0);
        $('ship-text').textContent = c.item_count === 0
          ? 'Free shipping from ' + money(thr, c.currency) + ' 🎃'
          : (left > 0 ? 'Only ' + money(left, c.currency) + ' left for free shipping 🦇' : 'Free shipping unlocked! 🧛');
      }
      $('cart-items').innerHTML = c.item_count === 0
        ? '<p class="empty">Your cart is empty… 🕸️</p>'
        : c.items.map(function (i) {
            var v = i.variant_title && i.variant_title.indexOf('Default') === -1 ? '<small>' + esc(i.variant_title) + '</small>' : '';
            return '<div class="line' + (i.image ? '' : ' noimg') + '">' +
              (i.image ? '<img src="' + esc(i.image) + '" alt="">' : '') +
              '<div><div class="t">' + esc(i.product_title) + '</div>' + v +
              '<div class="qtybox"><button data-k="' + esc(i.key) + '" data-q="' + (i.quantity - 1) + '" aria-label="Decrease">−</button><span>' + i.quantity +
              '</span><button data-k="' + esc(i.key) + '" data-q="' + (i.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
              '<div><strong>' + money(i.final_line_price, c.currency) + '</strong><br><button class="rm" data-k="' + esc(i.key) + '" data-q="0">Remove</button></div></div>';
          }).join('');
      $('cart-subtotal').textContent = money(c.total_price, c.currency);
      $('cart-checkout').setAttribute('href', checkoutUrl());
    }
    function load() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(render); }
    function change(key, q) {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
        .then(function (r) { return r.json(); }).then(render);
    }

    $('cart-open').addEventListener('click', function (e) { e.preventDefault(); open(); });
    $('cart-close').addEventListener('click', close);
    $('cart-overlay').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    $('cart-items').addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]');
      if (b) change(b.getAttribute('data-k'), parseInt(b.getAttribute('data-q'), 10));
    });

    /* promo code: automatically applied at checkout */
    $('promo-input').value = code;
    if (code) $('promo-msg').textContent = 'Code ' + code + ' applied to order ✓';
    $('promo-form').addEventListener('submit', function (e) {
      e.preventDefault();
      code = $('promo-input').value.trim().toUpperCase();
      try { localStorage.setItem('promo', code); } catch (err) {}
      $('promo-input').value = code;
      $('promo-msg').textContent = code ? 'Code ' + code + ' applied to order ✓' : '';
      $('cart-checkout').setAttribute('href', checkoutUrl());
    });

    /* add to cart without leaving the page */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.matches || !f.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return load(); })
        .then(function () { open(); bump(); })
        .catch(function () { f.submit(); });
    });
    load();
  }

  /* ---------- Horror effects ---------- */
  if (calm) return;
  var f = document.querySelector('.flash');
  function zap() {
    if (f) { f.classList.remove('on'); void f.offsetWidth; f.classList.add('on'); }
    setTimeout(zap, 8000 + Math.random() * 14000);
  }
  function bat() {
    var b = document.createElement('span');
    b.className = 'bat';
    b.textContent = '🦇';
    b.style.setProperty('--y', (Math.random() * 60 + 5) + 'vh');
    b.style.setProperty('--dy', (Math.random() * 160 - 80) + 'px');
    b.style.setProperty('--d', (6 + Math.random() * 6) + 's');
    document.body.appendChild(b);
    setTimeout(function () { b.remove(); }, 13000);
    setTimeout(bat, 4000 + Math.random() * 7000);
  }
  setTimeout(zap, 4000);
  bat();
})();
